import { motion } from 'framer-motion';
import ReactMarkdown from 'react-markdown';
import styles from './TermsOfService.module.css';
import termsSummaryData from './termsSummaryData';

const TermsOfService = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <motion.div 
      className={styles.modalOverlay}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      onClick={onClose}
    >
      <motion.div 
        className={styles.modalContent}
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.8 }}
        transition={{ duration: 0.3 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.closeButtonWrapper}>
          <button onClick={onClose} className={styles.closeButton}>✕</button>
        </div>
        <h1 className={styles.title}>{termsSummaryData.title}</h1>
        <p className={styles.lastUpdated}>{termsSummaryData.effective}</p>

        <a
          href="/terms"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.fullTermsLink}
        >
          Read the full Terms of Service →
        </a>

        {termsSummaryData.intro && (
          <div className={styles.section}>
            <ReactMarkdown className={styles.sectionContent} children={termsSummaryData.intro} />
          </div>
        )}

        {termsSummaryData.sections.map((section, index) => (
          <div key={index} className={styles.section}>
            <h2 className={styles.sectionTitle}>{section.title}</h2>
            <ReactMarkdown className={styles.sectionContent} children={section.content} />
          </div>
        ))}

        {termsSummaryData.closing && (
          <p className={styles.closing}>{termsSummaryData.closing}</p>
        )}

        <a
          href="/terms"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.fullTermsLink}
        >
          Read the full Terms of Service →
        </a>
      </motion.div>
    </motion.div>
  );
};

export default TermsOfService;
